import React from "react";
import { Link } from "react-router-dom";

// "Director's cut" CTA: uppercase, tracked-out, with a sliding solid triangle.
const DirectorButton = ({
  to,
  href,
  onClick,
  children,
  variant = "solid", // solid | outline
  color = "#edaa51",
  className = "",
  testId,
  type,
}) => {
  const base =
    "group inline-flex items-center gap-3 font-display text-xs md:text-sm font-bold uppercase tracking-[0.18em] px-7 py-4 rounded-full transition-all duration-300";
  const styles =
    variant === "solid"
      ? "text-ink hover:brightness-105"
      : "text-white border border-white/25 bg-white/5 backdrop-blur hover:bg-white/10";
  const inlineStyle = variant === "solid" ? { backgroundColor: color } : {};

  const Triangle = (
    <span
      className="inline-block w-0 h-0 transition-transform duration-300 group-hover:translate-x-1.5"
      style={{
        borderLeft: "7px solid currentColor",
        borderTop: "5px solid transparent",
        borderBottom: "5px solid transparent",
        color: variant === "solid" ? "#171726" : color,
      }}
    />
  );

  const content = (
    <>
      {children}
      {Triangle}
    </>
  );

  if (to)
    return (
      <Link to={to} onClick={onClick} data-testid={testId} className={`${base} ${styles} ${className}`} style={inlineStyle}>
        {content}
      </Link>
    );
  if (href) {
    const external = /^https?:/.test(href);
    return (
      <a
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
        data-testid={testId}
        className={`${base} ${styles} ${className}`}
        style={inlineStyle}
      >
        {content}
      </a>
    );
  }
  return (
    <button type={type || "button"} onClick={onClick} data-testid={testId} className={`${base} ${styles} ${className}`} style={inlineStyle}>
      {content}
    </button>
  );
};

export default DirectorButton;
